import React from 'react';

const Waveform = () => {
  const heights = [
    72, 120, 58, 142, 96, 132, 64, 112, 88, 150, 70, 126, 92, 138, 60, 116, 82,
    146, 74, 108, 90, 134, 68, 122, 86, 140, 62, 118, 80, 130,
  ];

  return (
    <svg
      className="pointer-events-none absolute top-1/2 hidden lg:block -translate-y-1/2 opacity-[0.035] z-0"
      width="420"
      height="300"
      viewBox="0 0 520 360"
      style={{ right: '-220px' }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g stroke="white" strokeWidth="1.4" strokeLinecap="round">
        {heights.map((h, i) => {
          const x = 120 + i * 12;
          const y1 = 180 - h / 2;
          const y2 = 180 + h / 2;
          return <line key={i} x1={x} y1={y1} x2={x} y2={y2} />;
        })}
      </g>
    </svg>
  );
};

const HeroHeadline = ({ testId = 'hero-headline' }) => {
  return (
    <section
      className="relative w-full overflow-hidden bg-[#07090b]"
      data-testid={testId}
    >
      {/* Base gradient */}
      <div
        className="absolute inset-0"
        aria-hidden="true"
        style={{
          background:
            'radial-gradient(900px 520px at 50% 42%, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.00) 60%), linear-gradient(180deg, #0b0d10 0%, #07090b 45%, #0a0c0f 100%)',
        }}
      />

      {/* Grid overlay */}
      <div
        className="absolute inset-0 opacity-[0.08]"
        aria-hidden="true"
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0.55) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.55) 1px, transparent 1px)',
          backgroundSize: '220px 180px',
          backgroundPosition: '0 0',
        }}
      />

      {/* Vignette */}
      <div
        className="absolute inset-0"
        aria-hidden="true"
        style={{
          boxShadow: 'inset 0 0 240px rgba(0,0,0,0.72)',
        }}
      />

      {/* Content */}
      <div className="relative mx-auto flex min-h-[400px] md:min-h-[520px] max-w-[1400px] items-center justify-center px-4 md:px-6 py-12 md:py-20 lg:min-h-[640px] lg:px-20">
        <Waveform />

        <div className="relative z-20 w-full max-w-4xl text-center">
          {/* Floating badge */}
          <div className="flex justify-center">
            <div
              className={
                'animate-fade-in-up opacity-0 [animation-delay:0ms] ' +
                'inline-flex items-center gap-2 md:gap-2.5 rounded-full border border-white/10 bg-white/5 px-3 md:px-5 py-2 md:py-2.5 ' +
                'backdrop-blur-md shadow-[0_0_18px_rgba(16,185,129,0.12)]'
              }
            >
              <span className="text-[10px] md:text-xs font-semibold uppercase tracking-[0.14em] text-white/60">
                BOOST ACCURACY
              </span>
              <span className="text-xs md:text-sm font-semibold text-red-400">34%</span>
              <span className="text-xs md:text-sm text-white/35">→</span>
              <span className="text-xs md:text-sm font-semibold text-emerald-400">98%</span>
            </div>
          </div>

          {/* Headline */}
          <h1
            className={
              'mt-5 md:mt-9 animate-fade-in-up opacity-0 [animation-delay:180ms] ' +
              'text-[36px] md:text-5xl font-semibold tracking-tight text-white sm:text-6xl lg:text-7xl xl:text-[92px] leading-[1.18] md:leading-[1.14] pt-2 whitespace-nowrap'
            }
            style={{
              backgroundImage: 'linear-gradient(180deg, #ffffff 0%, #cfd6df 100%)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent',
              fontFamily: "'Martel Sans', sans-serif",
            }}
          >
            <span className="text-[var(--pluckr-green)]">Pluck.</span>{' '}Build.{' '}
            <span className="text-[var(--pluckr-green)]">Ship.</span>
          </h1>

          {/* Subtitle */}
          <p
            className={
              'mt-5 md:mt-7 animate-fade-in-up opacity-0 [animation-delay:340ms] ' +
              'mx-auto max-w-3xl text-sm md:text-base leading-relaxed text-white/55 sm:text-lg lg:text-xl px-2'
            }
            style={{ fontFamily: "'Martel Sans', sans-serif" }}
          >
            Turn AI-generated code into production-ready software with MCPs for payments, backend, and infrastructure.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroHeadline;
